import Cookies from 'js-cookie'

const TokenKey = 'Authorization'
const UserKey = 'UserKey'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  if (typeof token === 'string') {
    return Cookies.set(TokenKey, token)
  } else {
    return Cookies.set(TokenKey, token.token)
  }
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUser() {
  return Cookies.get(UserKey)
}

export function setUser(user) {
  return Cookies.set(UserKey, user)
}

export function removeUser() {
  return Cookies.remove(UserKey)
}
